import Auth from './auth';
import Participant from './participant';
import Trainer from './trainer';

export default {
  Auth,
  Participant,
  Trainer,
}